<template>
    <div>
        <div v-if="hasOrders">
            <b-dropdown text="Ergebnisse pro Seite" class="m-md-2">
                <b-dropdown-item @click="setPerPage(10)">10</b-dropdown-item>
                <b-dropdown-item @click="setPerPage(20)">20</b-dropdown-item>
                <b-dropdown-item @click="setPerPage(50)">50</b-dropdown-item>
                <b-dropdown-item @click="setPerPage(100)">100</b-dropdown-item>
            </b-dropdown>
            <b-table 			
                id="tableToShow"
                striped hover class="mt-3"
                :items="customerOrders"
                :fields="fields"
                size="sm"
                :per-page="perPage"
                :current-page="currentPage">                
            </b-table>
            <!--    idea for second table is, to have a table that does not need to update the sortable Arrows, which mess up 
                    the format of excel and PDF files. It will be rendered but not shown except for exporting it as PDF-->
            <div id="elementToExport">                      
            <b-table
                v-show="showExportTable" 			
                id="tableToExport"
                striped hover class="mt-3"
                :items="customerOrders"
                :fields="fieldsNoSort"
                size="sm">
            </b-table>
            </div> 
            <b-button variant="primary" @click="exportToXLSX()">Export to Excel</b-button>
            <b-button variant="primary" @click="exportToPDF()">Export to PDF</b-button>                           
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
        </div>
        <div v-else>
            Es wurden keine eingehenden Bestellungen gefunden.
        </div>
    </div>
</template>
<script>
import html2pdf from "html2pdf.js";

export default{

    props:{
        passedCustomerOrders:{
            type: Array,
            required: true
        }
    },
    data(){
        return{
            customerOrders : this.passedCustomerOrders,
            hasOrders : Boolean(this.passedCustomerOrders.length),
            fields:[             
                {key: 'order_log.customerorder.id'          ,label:'Bestellnummer'             ,sortable: true},
                {key: 'barcode'                             ,label:'Barcode'                   ,sortable: true},
                {key: 'delivery_note.number'                ,label:'Lieferscheinnummer'        ,sortable: true},                
                {key: 'delivery_note.date'                  ,label:'Lieferscheindatum'         ,sortable: true, formatter: this.dateFormatter},
            ],
            fieldsNoSort:[             
                {key: 'order_log.customerorder.id'          ,label:'Bestellnummer'             ,sortable: false},
                {key: 'barcode'                             ,label:'Barcode'                   ,sortable: false},
                {key: 'delivery_note.number'                ,label:'Lieferscheinnummer'        ,sortable: false},                
                {key: 'delivery_note.date'                  ,label:'Lieferscheindatum'         ,sortable: false, formatter: this.dateFormatter},
            ],            
            perPage : 10,
            currentPage: 1,
            showExportTable: false
        }
    },
    methods :{
        setPerPage(perPageResults){
            this.perPage = perPageResults;
        },
        dateFormatter(value){
            return moment(value).format('HH:mm DD.MM.YYYY')
        },
        exportToXLSX(){
            let currentDate = moment().format("DD.MM.YYYY");
                const wb = XLSX.utils.table_to_book(this.$el.querySelector('#tableToExport'),{sheet: currentDate});
                XLSX.writeFile(wb, "Zulaufexport-"+currentDate+".xlsx");
        },
        //
        exportToPDF(){
            let currentDate = moment().format("DD.MM.YYYY");
            this.showExportTable = true;
            Vue.nextTick().then(()=>{
                let options =   {margin: 2,
                                filename: "Zulaufexport-"+currentDate+".pdf",
                                pagebreak: {mode: 'avoid-all', before: '.tr'},
                                //landscape - horizontal //portrait - vertical - default
                                jsPDF: {orientation : 'landscape'}
                                }
                const element = this.$el.querySelector('#tableToExport');
                html2pdf(element, options)
            this.showExportTable = false;
            })
            // documentation for html2pdf:
            //https://ekoopmans.github.io/html2pdf.js/
        },        
    },
    computed:{
        totalRows(){
            return this.customerOrders.length;
        }
    },
    created(){
    },
    mounted() {
    }

}
</script>